import { useReducer, createContext } from 'react'
import {
  TASK_FILE_STATUS,
  REMOVE_FILE,
  INIT_TASK_FILE_STATUS,
} from './VendorActionType'
import { cloneDeep } from 'lodash'

export const VendorContext = createContext()

const initialState = {
  taskFileStatus: {},
}

const reducer = (state = initialState, action) => {
  // let { taskListData } = action.payload
  const { tcin, fileStatesList, name } = action.payload
  const newTaskFileStatus = cloneDeep(state.taskFileStatus)
  switch (action.type) {
    case INIT_TASK_FILE_STATUS:
      return {
        ...state,
        taskFileStatus: action.payload,
      }

    case TASK_FILE_STATUS:
      //   console.log(newTaskFileStatus[tcin], name)

      if (newTaskFileStatus[tcin] && newTaskFileStatus[tcin][name]) {
        fileStatesList[name] = {
          ...newTaskFileStatus[tcin][name],
          ...fileStatesList[name],
        }

        if (fileStatesList[name].success_chunk) {
          fileStatesList[name]['success_count'] = Array.isArray(
            newTaskFileStatus[tcin][name]['success_count']
          )
            ? [
                ...newTaskFileStatus[tcin][name]['success_count'],
                fileStatesList[name].success_chunk,
              ]
            : [fileStatesList[name].success_chunk]
          fileStatesList[name]['progress'] =
            (fileStatesList[name]['success_count'].length /
              fileStatesList[name].totalChunks) *
            100
          fileStatesList[name]['slowConnection'] =
            (performance.now() - fileStatesList[name].startTime) /
              fileStatesList[name]['success_count'].length >
            2000
              ? true
              : false
        }
      }

      newTaskFileStatus[tcin] = {
        ...newTaskFileStatus[tcin],
        ...fileStatesList,
      }
      return {
        ...state,
        taskFileStatus: newTaskFileStatus,
      }
    case REMOVE_FILE:
      try {
        delete newTaskFileStatus[action.payload.tcin][action.payload.key]
        return {
          ...state,
          taskFileStatus: newTaskFileStatus,
        }
      } catch (e) {
        return { ...state }
      }
    default:
      return state
  }
}

export const VendorContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  return (
    <VendorContext.Provider value={[state, dispatch]}>
      {props.children}
    </VendorContext.Provider>
  )
}
